
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Vitamin B2 könnte eventuell etwas bringen, aber es gibt – wie so oft bei
komplementären Methoden – nur wenige wissenschaftliche Studien dazu. Deshalb
herrscht auch Uneinigkeit, was die Dosis betrifft: Ein US-Fachmann weist darauf
hin, dass 25 Milligramm pro Tag bereits hilfreich sein können. Hiesige Experten
dagegen raten zu 400 Milligramm täglich, mit Verweis auf eine Studie, bei der –
nach dreimonatiger Einnahme des Vitamins – über die Hälfte der Patienten nur
noch halb so oft an Migräne litten. Auch die Schmerzintensität sank bei mehr als
jedem Dritten.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;